var map = {
	"./Frame-bg-fire-image.png": 602,
	"./Framehero_ujjo.png": 555,
	"./IMAGE-hero-2.jpg": 511,
	"./IMAGE-hero1.jpg": 547,
	"./IMAGE-mainPage-container-image.jpg": 951,
	"./IMAGE-products-circle-file.png": 57,
	"./IMAGE-products-image.png": 243,
	"./IMAGE-products-main-fire.png": 737,
	"./IMAGE-products-title-left.png": 660,
	"./IMAGE-products-title-right.png": 101,
	"./IMAGE-story-bg.png": 925,
	"./IMAGE-ticker-paper.png": 520,
	"./IMAGE_header_logo_ujjo.png": 388,
	"./IMAGEproduct-bg-card.png": 311,
	"./image 1-mainPage-gif.jpg": 523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 235;